<div>
  <div class="prev-bar">
      <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p>{{'domesticHelperClaim.dmhClaimTypeDetails.helpersLiability.detailsOfIncident.detailsOfIncident' | translate}}</p>
  </div>
  <BR>

  <div class="row col-12">
    <div class="col-xl-9 col-lg-12">
        <form>
            <div class="form-group">
                <qnect-ui #DMH_HELPERS_LIABILITY_INCIDENT_DATE [fieldId]="'DMH_HELPERS_LIABILITY_INCIDENT_DATE'" [formGroup]="helpersLiabilityForm" name="dateOfIncident"></qnect-ui>
              </div>
              <div class="form-group">
                  <qnect-ui #DMH_HELPERS_LIABILITY_INCIDENT_OCCUR [fieldId]="'DMH_HELPERS_LIABILITY_INCIDENT_OCCUR'" [formGroup]="helpersLiabilityForm" name="countryIncidentOccurDesc"></qnect-ui>
              </div>
              <div class="form-group">  
                <qnect-ui #DMH_HELPERS_LIABILITY_NATURE_OF_INCIDENT [fieldId]="'DMH_HELPERS_LIABILITY_NATURE_OF_INCIDENT'" [formGroup]="helpersLiabilityForm" name="natureOfIncident"></qnect-ui>             
              </div>

        </form>
    </div>
    <div class="col-xl-3 col-lg-12">
    </div>
  </div>

<div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary">{{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn new-btn btn-primary float-right"> {{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}} <i class="fas fa-arrow-right" ></i></button>
</div>
<app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>

